import { render, staticRenderFns } from "./InstructionTour.vue?vue&type=template&id=1e72c9ce&scoped=true"
import script from "./InstructionTour.vue?vue&type=script&lang=js"
export * from "./InstructionTour.vue?vue&type=script&lang=js"
import style0 from "./InstructionTour.vue?vue&type=style&index=0&id=1e72c9ce&prod&lang=css"
import style1 from "./InstructionTour.vue?vue&type=style&index=1&id=1e72c9ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e72c9ce",
  null
  
)

export default component.exports